<template>
  <div class="flex flex-col flex-1">
    <div class="w-full px-6 h-20 border-b flex-shrink-0">
      <div class="max-w-7xl h-full w-full flex justify-center items-center mx-auto relative">
        <div class="absolute left-0 inset-y-0 flex items-center">
          <button type="button" class="sm:hidden text-sm text-payneHot font-medium focus:outline=none" @click="$emit('close')">
            Close
          </button>
        </div>
        <h4 class="text-yank">
          <slot name="title"></slot>
        </h4>
      </div>
    </div>
    <div class="flex-1 p-6 sm:p-10">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SettingsPanel'
  }
</script>
